export type NotificationsActions = SetIsDeleting | RemoveNotification | SetNotificationsIsOpened;

export const SET_IS_DELETING = 'SET_IS_DELETING' as const;
export const setIsDeleting = (id: string, isDeleting: boolean) => ({
  type: SET_IS_DELETING,
  id,
  isDeleting,
});
export type SetIsDeleting = ReturnType<typeof setIsDeleting>;

export const REMOVE_NOTIFICATION = 'REMOVE_NOTIFICATION' as const;
export const removeNotification = (id: string) => ({
  type: REMOVE_NOTIFICATION,
  id,
});
export type RemoveNotification = ReturnType<typeof removeNotification>;

export const SET_NOTIFICATIONS_IS_OPENED = 'SET_NOTIFICATIONS_IS_OPENED' as const;
export const setNotificationsIsOpened = () => ({
  type: SET_NOTIFICATIONS_IS_OPENED,
});
export type SetNotificationsIsOpened = ReturnType<typeof setNotificationsIsOpened>;
